export default __webpack_public_path__ + "assets/ico_booking_common-dba0abc7.svg";